var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: { title: _vm.formTitle, size: "50%", visible: _vm.formVisible },
      on: {
        "update:visible": function($event) {
          _vm.formVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.dataForm,
            "label-width": "120px",
            rules: _vm.formRules
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "显示序号:", prop: "Order" } },
            [
              _c("el-input-number", {
                model: {
                  value: _vm.dataForm.Order,
                  callback: function($$v) {
                    _vm.$set(_vm.dataForm, "Order", $$v)
                  },
                  expression: "dataForm.Order"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "测试项目:", prop: "CheckType" } },
            [
              _c("enumSelector2", {
                ref: "enumSelector",
                attrs: {
                  options: _vm.$config.checkType,
                  clearable: false,
                  size: "small"
                },
                model: {
                  value: _vm.dataForm.CheckType,
                  callback: function($$v) {
                    _vm.$set(_vm.dataForm, "CheckType", $$v)
                  },
                  expression: "dataForm.CheckType"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "处方类型:", prop: "PrescType" } },
            [
              _c("enumSelector2", {
                ref: "enumSelector",
                attrs: {
                  options: _vm.$config.prescType,
                  clearable: false,
                  size: "small"
                },
                model: {
                  value: _vm.dataForm.PrescType,
                  callback: function($$v) {
                    _vm.$set(_vm.dataForm, "PrescType", $$v)
                  },
                  expression: "dataForm.PrescType"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "测试分值≤:", prop: "LessEqualScore" } },
            [
              _c("el-input-number", {
                model: {
                  value: _vm.dataForm.LessEqualScore,
                  callback: function($$v) {
                    _vm.$set(_vm.dataForm, "LessEqualScore", $$v)
                  },
                  expression: "dataForm.LessEqualScore"
                }
              })
            ],
            1
          ),
          _c("el-divider", [_vm._v("运动提升计划")]),
          _c(
            "el-form-item",
            { attrs: { label: "训练类别:", prop: "ActionWay" } },
            [
              _c("el-input", {
                attrs: {
                  "auto-complete": "off",
                  placeholder: "请输入训练类别",
                  disabled: _vm.readOnly
                },
                model: {
                  value: _vm.dataForm.ActionWay,
                  callback: function($$v) {
                    _vm.$set(_vm.dataForm, "ActionWay", $$v)
                  },
                  expression: "dataForm.ActionWay"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "提升内容:", prop: "ActionModule" } },
            [
              _c("el-input", {
                attrs: {
                  "auto-complete": "off",
                  placeholder: "请输入强化提升内容",
                  disabled: _vm.readOnly
                },
                model: {
                  value: _vm.dataForm.ActionModule,
                  callback: function($$v) {
                    _vm.$set(_vm.dataForm, "ActionModule", $$v)
                  },
                  expression: "dataForm.ActionModule"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "负荷强度:", prop: "ActionLoad" } },
            [
              _c("el-input", {
                attrs: {
                  "auto-complete": "off",
                  placeholder: "请输入负荷强度",
                  disabled: _vm.readOnly
                },
                model: {
                  value: _vm.dataForm.ActionLoad,
                  callback: function($$v) {
                    _vm.$set(_vm.dataForm, "ActionLoad", $$v)
                  },
                  expression: "dataForm.ActionLoad"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "训练器材:", prop: "Equipment" } },
            [
              _c("el-input", {
                attrs: {
                  "auto-complete": "off",
                  placeholder: "请输入训练器材",
                  disabled: _vm.readOnly
                },
                model: {
                  value: _vm.dataForm.Equipment,
                  callback: function($$v) {
                    _vm.$set(_vm.dataForm, "Equipment", $$v)
                  },
                  expression: "dataForm.Equipment"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "运动频次:", prop: "ActionFrequency" } },
            [
              _c("el-input", {
                attrs: {
                  "auto-complete": "off",
                  placeholder: "请输入训练周期及频次",
                  disabled: _vm.readOnly
                },
                model: {
                  value: _vm.dataForm.ActionFrequency,
                  callback: function($$v) {
                    _vm.$set(_vm.dataForm, "ActionFrequency", $$v)
                  },
                  expression: "dataForm.ActionFrequency"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "时间要求:", prop: "TimeMin" } },
            [
              _c("el-input-number", {
                staticStyle: { width: "40%" },
                attrs: {
                  "auto-complete": "off",
                  placeholder: "分钟",
                  disabled: _vm.readOnly
                },
                model: {
                  value: _vm.dataForm.TimeMin,
                  callback: function($$v) {
                    _vm.$set(_vm.dataForm, "TimeMin", $$v)
                  },
                  expression: "dataForm.TimeMin"
                }
              }),
              _vm._v("分 "),
              _c("el-input-number", {
                staticStyle: { width: "40%" },
                attrs: {
                  "auto-complete": "off",
                  placeholder: "秒",
                  disabled: _vm.readOnly
                },
                model: {
                  value: _vm.dataForm.TimeSec,
                  callback: function($$v) {
                    _vm.$set(_vm.dataForm, "TimeSec", $$v)
                  },
                  expression: "dataForm.TimeSec"
                }
              }),
              _vm._v("秒 ")
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注:", prop: "Desc" } },
            [
              _c("el-input", {
                attrs: {
                  "auto-complete": "off",
                  placeholder: "请输入备注",
                  disabled: _vm.readOnly
                },
                model: {
                  value: _vm.dataForm.Desc,
                  callback: function($$v) {
                    _vm.$set(_vm.dataForm, "Desc", $$v)
                  },
                  expression: "dataForm.Desc"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "示例图片:", prop: "Image" } },
            [
              _vm.dataForm.Image
                ? _c("img", {
                    key: _vm.dataForm.Image,
                    staticStyle: { height: "100px" },
                    attrs: { src: _vm.baseUrl + _vm.dataForm.Image }
                  })
                : _vm._e(),
              _c(
                "el-button",
                {
                  staticClass: "submit-btn",
                  attrs: { type: "warning", size: "mini" },
                  on: { click: _vm.selectFile }
                },
                [_vm._v("点此上传")]
              )
            ],
            1
          ),
          !_vm.readOnly
            ? _c("el-form-item", [
                _c(
                  "div",
                  { staticClass: "footer" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleSubmit }
                      },
                      [_vm._v("提交")]
                    )
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _c("fileUploadNoUI", {
        ref: "fileUploadNoUI",
        on: { uploadSuccess: _vm.uploadSuccess }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }